<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">预计价格（仅作参考，以实际服务为准）</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>服务费用</p>
            </div>
            <div class="weui-cell__ft">具体服务完成后确定</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>定金费用（可抵扣尾款费用）</p>
            </div>
            <div class="weui-cell__ft">{{20 | numeral('$0,0.00')}}</div>
        </a>


      </div>
      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/general-step4')">
            <div class="weui-cell__bd">
                <p>联系方式</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_name + " " + order.data.address_phone}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/general-step3')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/general-step4')">
            <div class="weui-cell__bd">
                <p>服务地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_street}}, {{order.data.address_suburb}}, {{order.data.address_state}}, {{order.data.address_postcode}}</div>
        </a>


      </div>
      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>
      <br>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>
      <div class="js_dialog" v-show="couponValid">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">使用成功!</strong></div>
              <div class="weui-dialog__bd">优惠码有效，尾款可享优惠 ${{order.data.couponValue}}</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="couponValid=false">好的</div>
              </div>
          </div>
      </div>
      <div class="js_dialog" v-show="couponInvalid">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">使用失败</strong></div>
              <div class="weui-dialog__bd">优惠码无效，请检查输入是否正确</div>
              <div class="weui-dialog__ft">
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="couponInvalid=false">好的</div>
              </div>
          </div>
      </div>
      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('cangchu','step5')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      ifCoupon:false,
      isSending:false,
      isSubmiting:false,
      couponValid:false,
      couponInvalid:false,
    }
  },
  methods: {
    editData(url){
      localStorage.isEditing = '/general-step6';
      this.$router.push(url);
    },
    useCoupon(text){
      this.ifCoupon = true;
      this.sleep(20).then(() => {
        this.$refs.couponRef.focus();
      });
    },
    cancelCoupon(){
      this.ifCoupon = true;
      this.orderUpdate('coupon','');
      this.orderUpdate('couponLocked',false);
    },
    applyCoupon(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;
        let couponText = {};
        couponText.coupon = this.order.data.coupon;

        this.axios.post(this.apiURL()+'/Coupon/getCouponAmount', qs.stringify(couponText))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending=false;
            that.couponValid = true;
            that.orderUpdate('coupon',that.order.data.coupon);
            that.orderUpdate('couponLocked',true);
            that.orderUpdate('couponValue',response.data.data.relevance);
          }
          else{
            that.isSending=false;
            that.couponInvalid = true;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/general-step4');
      }
    },
    submitOrder(){
      this.isSubmiting = false;
      
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('agency',this.order.data.agency);

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735978;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.username;
            orderObject.member_phone = orderObject.userphone;
        }

        if(orderObject.return_pending=='0'){
            orderObject.return_street = orderObject.pick_street;
            orderObject.return_suburb = orderObject.pick_suburb;
            orderObject.return_postcode = orderObject.pick_postcode;
        }

        orderObject.pick_date = new Date(orderObject.pick_date);
        orderObject.pick_date = Vue.filter('moment')(orderObject.pick_date,"YYYY-MM-DD");
        
        orderObject['order_source'] = '3';

        console.log(orderObject);


      }
    },
  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "general"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}


.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/general/step6.vue